export default __webpack_public_path__ + "static/media/c013-2.6cdb8e5b.png";